import { render, staticRenderFns } from "./ModalExcluirComposto.vue?vue&type=template&id=7aa11c86&"
import script from "./ModalExcluirComposto.vue?vue&type=script&lang=js&"
export * from "./ModalExcluirComposto.vue?vue&type=script&lang=js&"
import style0 from "./ModalExcluirComposto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports